import React, { useState } from "react";
import CategoriesList from "./CategoriesList";
import AddCategories from "./addCategories/AddCategories";

function Categories({list,data,checkBoxHandler,listFromRedux,onClickHitApi,isFetchCat,getCategory}) {
  const [isAddCategory, setIsAddCategory] = useState(false);
  const addCategory = () => {
    setIsAddCategory(true);
  };
  return (
    <React.Fragment>
      <div className="categories__Wrapper">
        <h5 className="mb-2 font-medium text-sm">Categories</h5>
        <CategoriesList list={list} listFromRedux={listFromRedux} />
        <p className=" text-gray-700 mb-0 text-right fs-13 cursor-pointer bg-gray-200 inline-block px-3 py-1 rounded mt-4 hover:bg-gray-300 hover:text-gray-800" onClick={() => addCategory()}>
          Add Categories
        </p>
      </div>
      <AddCategories getCategory={getCategory} onClickHitApi={onClickHitApi} isFetchCat={isFetchCat} checkBoxHandler={checkBoxHandler} isAddCategory={isAddCategory} data={data} list={list} close={() => setIsAddCategory(false)}/>
    </React.Fragment>
  );
}

export default Categories;
